import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Cell } from "recharts";

import styles from "./oa-chart.module.scss";

const OAChart = ({ chartData, onChartClick }) => {
	if (!chartData || chartData.length === 0) {
		return (
			<div className={styles.graph} style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "300px" }}>
				<div style={{ textAlign: "center", color: "#666" }}>
					<p>No hay datos disponibles para mostrar</p>
					<p style={{ fontSize: "12px", marginTop: "8px" }}>Seleccione filtros y haga clic en "Aplicar Filtros"</p>
				</div>
			</div>
		);
	}

	return (
		<div className={styles.graph}>
			<ResponsiveContainer width="100%" height="100%">
				<BarChart data={chartData} margin={{ top: 20, right: 20, left: 0, bottom: 0 }} onClick={onChartClick}>
					<XAxis dataKey="label" tick={{ fontSize: 12 }} angle={-45} textAnchor="end" height={80} />
					<YAxis tickFormatter={(value) => value.toString()} tick={{ fontSize: 12 }} />
					<CartesianGrid strokeDasharray="3 3" vertical={false} />
					<Tooltip
						content={({ active, payload, label }) => {
							if (active && payload && payload.length) {
								return (
									<div
										style={{
											backgroundColor: "#fff",
											border: "1px solid #ccc",
											padding: "8px",
											borderRadius: "6px",
										}}
									>
										<p
											style={{
												margin: 0,
												fontSize: "13px",
												fontWeight: 500,
												color: "#374151",
											}}
										>
											{label}: {payload[0].value} órdenes
										</p>
									</div>
								);
							}
							return null;
						}}
					/>
					<Bar dataKey="value" isAnimationActive={false}>
						{chartData.map((entry, index) => (
							<Cell key={`cell-${index}`} fill={entry.fill} />
						))}
					</Bar>
				</BarChart>
			</ResponsiveContainer>
		</div>
	);
};

export default OAChart;
